import {APIError} from '../core/errors';
import {employeePaymentRequest, requestPaymentLinkResponse} from '../lib/types';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/order/request-link-payment`;

export const requestPaymentPaymentApiCall = async (
  parameters: employeePaymentRequest,
): Promise<requestPaymentLinkResponse> => {
  //todo
  // dob has to be non mandatory

  try {
    const response = await httpClient.post(
      `${_api_base_url}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
